module.exports = __webpack_public_path__ + "static/img/jinsaiyaoye.e24bf3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/jinsaiyaoye.jpg
// module id = CIht
// module chunks = 0